import script from "./InfoBox_Left.vue?vue&type=script&setup=true&lang=ts"
export * from "./InfoBox_Left.vue?vue&type=script&setup=true&lang=ts"

import "./InfoBox_Left.vue?vue&type=style&index=0&id=c6de4f36&scoped=true&lang=scss"

import exportComponent from "../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c6de4f36"]])

export default __exports__